export const INCENSE_LINES = [
    { slug: 'incense-zipper-pouches', name: 'Premium Incense Zipper Pouches', label: 'Zip Pouches', pack: '90 g' },
    { slug: 'incense-sticks-100g', name: 'Premium Incense Sticks 100g', label: 'Incense Sticks', pack: '100 g' },
    { slug: 'incense-sticks-33', name: 'Premium Incense Sticks 33', label: 'Incense Sticks', pack: '33 sticks' },
    { slug: 'incense-packs-10', name: 'Premium Incense Stick Packs', label: 'Incense Packs', pack: '10 sticks' },
];

export const DHOOP_LINES = [
    { slug: 'dhoop-sticks-100g', name: 'Premium Dhoop Sticks 100g', label: 'Dhoop Sticks', pack: '100 g' },
    { slug: 'dhoop-sticks-10', name: 'Premium Dhoop Sticks 10', label: 'Dhoop Sticks', pack: '10 sticks' },
    { slug: 'dhoop-packs-90', name: 'Premium Dhoop Stick Packs 90g', label: 'Dhoop Packs', pack: '90 g' },
    { slug: 'dhoop-cups', name: 'Premium Dhoop Cups', label: 'Dhoop Cups', pack: '12 cups' },
];

export const SHOP_FAMILIES = [
    {
        key: 'incense',
        title: 'Incense',
        href: '/incense',
        seoTitle: 'Agarbatti & Incense Sticks',
        description: 'Charcoal-free gomay agarbatti and incense sticks for daily puja.',
        slugs: INCENSE_LINES.map((line) => line.slug),
        lines: INCENSE_LINES,
        image: '/assets/images/collection_incense_sticks_1764862333586.webp',
    },
    {
        key: 'dhoop',
        title: 'Dhoop',
        href: '/dhoop',
        seoTitle: 'Dhoop Sticks',
        description: 'Cow dung dhoop sticks, dhup packs, and sambrani cups.',
        slugs: DHOOP_LINES.map((line) => line.slug),
        lines: DHOOP_LINES,
        image: '/assets/images/collection_dhoop_sticks_1764862353813.webp',
    },
    {
        key: 'cups',
        title: 'Dhoop Cups',
        href: '/dhoop-cups',
        description: 'Twelve-cup sambrani boxes for a lasting sacred fragrance.',
        slugs: ['dhoop-cups'],
        lines: [DHOOP_LINES[3]],
        image: '/assets/images/collection_havan_cups_1764862408665.webp',
    },
    {
        key: 'soon',
        title: 'Coming Soon',
        href: '/launching-soon',
        description: 'Jars, bambooless incense, and camphor for the prayer shelf.',
        slugs: ['launching-soon'],
        lines: [{ slug: 'launching-soon', label: 'Launching Soon', pack: '' }],
        image: '/assets/images/collection_dhoop_cones_1764862379070.webp',
    },
];

export const AMAZON_SHOP = 'https://www.amazon.in/s?k=praypure';
export const FLIPKART_SHOP = 'https://www.flipkart.com/search?q=praypure';
export const CONTACT_PHONE = '+91 63556 59566';
export const CONTACT_PHONE_TEL = '+916355659566';
export const CONTACT_WHATSAPP = 'https://wa.me/916355659566';
export const CONTACT_EMAIL = 'support@praypure.com';
